import { render, staticRenderFns } from "./MarketingCampaignList.vue?vue&type=template&id=21d7459c&scoped=true&"
import script from "./MarketingCampaignList.vue?vue&type=script&lang=js&"
export * from "./MarketingCampaignList.vue?vue&type=script&lang=js&"
import style0 from "./MarketingCampaignList.vue?vue&type=style&index=0&id=21d7459c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d7459c",
  null
  
)

export default component.exports